<sz-bottom-sheet [open]="open()" (close)="close.emit()">
  <div szSheetHeader class="numpad-sheet__header">
    <div class="numpad-sheet__head-text">
      <div class="numpad-sheet__kicker" [class.numpad-sheet__kicker--neutral]="mode() === 'edit'">
        @if (mode() === 'add') {
          <sz-live-dot />
        }
        @if (context(); as c) {
          @if (mode() === 'edit') {
            {{ 'session.numpad.editKicker' | translate: { run: formatRun(c.runNumber) } }}
          } @else {
            {{ 'session.numpad.addKicker' | translate: { run: formatRun(c.runNumber), target: c.targetRuns ?? '' } }}
          }
        }
      </div>
      @if (context(); as c) {
        <div class="numpad-sheet__title">{{ c.drillName }}{{ c.secondaryLine ? ' · ' + c.secondaryLine : '' }}</div>
      }
    </div>
    @if (mode() === 'edit') {
      <sz-button variant="danger-ghost" size="sm" (click)="onDeleteClick()">
        <sz-icon name="trash" [size]="13" />
        {{ 'common.delete' | translate }}
      </sz-button>
    } @else {
      <sz-icon-button icon="x" size="sm" [ariaLabel]="'common.close' | translate" (click)="close.emit()" />
    }
  </div>

  <div class="numpad-sheet__body">
    @switch (variant()) {
      @case ('tpr') {
        <lib-numpad-tpr
          [initialPayload]="initialPayload()"
          [resetTrigger]="resetTrigger()"
          (submitRun)="onVariantSubmit($event)"
          (cancel)="onVariantCancel()" />
      }
      @case ('reps') {
        <lib-numpad-reps
          [initialPayload]="initialPayload()"
          [resetTrigger]="resetTrigger()"
          (submitRun)="onVariantSubmit($event)"
          (cancel)="onVariantCancel()" />
      }
      @case ('hf-time') {
        <lib-numpad-tpr
          [initialPayload]="initialPayload()"
          [resetTrigger]="resetTrigger()"
          (submitRun)="onVariantSubmit($event)"
          (cancel)="onVariantCancel()" />
      }
      @default {
        <p class="numpad-sheet__placeholder">{{ 'session.numpad.variantPlaceholder' | translate }}</p>
      }
    }
  </div>
</sz-bottom-sheet>
